import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    textTransform: 'uppercase',
    color: colors.darkestGray,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      maxWidth: '70%',
    },
  },
  actionLabel: {
    float: 'right',
    color: colors.darkestBlue,
    fontWeight: 'bold',
  },
  actionSwitch: {
    float: 'right',
    marginTop: -8,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'start',
    },
  },
  divider: {
    margin: '24px 0 -8px 0',
  },
}));
